// Display helpers for proposal contact blocks (PDF + UI previews).

import { formatPhoneStrict } from "../lead/phones.js";

/** US phone display for proposals: (###) ###-#### when 10 digits. */
export function formatProposalContactPhone(phone: string | null | undefined): string | null {
  const raw = phone?.trim();
  if (!raw) return null;
  return formatPhoneStrict(raw) ?? raw;
}

/**
 * When a sales rep's active location contributes contact details, extend
 * the org line to "[Business Name] - [Location Name]".
 */
export function proposalContactOrgWithLocation(
  orgName: string,
  locationName: string | null | undefined,
): string {
  const base = orgName.trim();
  const loc = locationName?.trim();
  if (!loc) return base;
  if (!base) return loc;
  if (base.toLowerCase().endsWith(` - ${loc.toLowerCase()}`)) return base;
  return `${base} - ${loc}`;
}
